module.exports = __webpack_public_path__ + "img/office-2.c8e79db0.jpg";